<template>
  <div>
    <yxtf-popover
    v-model="showTeamSel"
    class="mv24 ml32 hand d-in-block text-26 o20-myteam-content_sel_team"
    popper-class="team-select-self-height"
    placement="bottom-start"
    trigger="manual"
    lazy="true"
    effect>
    <div style='height: 100%;'>
      <yxtf-tree
        node-key="teamId"
        popper-class="team-pop"
        lazy
        :load="loadNode"
        :props="teamProps"
        :expand-on-click-node="false"
        @node-click="handleTeamNodeClick"></yxtf-tree>
    </div>
    <span slot="reference" class="standard-size-20" @click="showTeamSel = isShowTeamSel? !showTeamSel: showTeamSel">
      <span>{{ selTeamName }}</span>
      <span v-show="isShowTeamSel" class="ml3 standard-size-16" :class="showTeamSel ? 'yxt-icon-arrow-up' : 'yxt-icon-arrow-down'"></span>
    </span>
  </yxtf-popover>
  </div>
</template>

<script>
import { getTeamList, getTeamDeptsList } from './service';
export default {
  name: 'YxtbizSelectTeam',
  props: {
    tId: {
      type: String,
      default: ''
    },
    tName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      showTeamSel: false, // 下拉框展示
      isShowTeamSel: false, // 是否展示部门下拉框按钮
      teamProps: { // 我的部门/直属团队下拉框数据格式
        children: 'zones',
        label: 'teamName',
        isLeaf: 'leaf'
      },
      selTeamName: '', // 选中团队名称
      defaultTid: this.$route.query.teamId || this.tId,
      defaultTname: this.$route.query.teamName || this.tName,
      defaultDeptId: this.$route.query.deptid
    };
  },
  created() {
  },
  mounted() {
    if (window.localStorage.getItem('myTeam_userId') === window.localStorage.getItem('userId')) {
      if (window.localStorage.getItem('myTeam_TeamDetail')) {
        const myteamBoardDataAll = JSON.parse(window.localStorage.getItem('myTeam_TeamDetail'));
        this.defaultTid = myteamBoardDataAll.id;
        this.defaultTname = myteamBoardDataAll.name;
        this.defaultDeptId = myteamBoardDataAll.deptid;
      };
    } else {
      window.localStorage.setItem('myTeam_userId', window.localStorage.getItem('userId'));
      window.localStorage.removeItem('myTeam_TeamDetail');
    }
  },
  watch: {
  },
  methods: {
    // 加载团队下拉框树
    loadNode(node, resolve) {
      // 如果是第一级
      let teamId = '';
      let isDept = 0;
      if (node && node.data) {
        // 设置选中
        teamId = node.data.teamId;
        isDept = node.data.isDept;
      }
      // 如果选择了【我的部门】需要加载部门列表数据 并追加到树
      if (isDept === 1) {
        // 初次绑定我的部门下的部门树，需要调接口
        if (teamId === '00000000-0000-0000-0000-000000000000') {
          const param = {
            dataPermissionCode: '',
            navCode: '',
            scope: '0',
            type: 2,
            teamId: 'deptManager'
          };
          getTeamDeptsList(param).then(res => {
            if (res && res.datas && res.datas.length > 0) {
              res.datas[0].children.forEach(item => {
                item.isDept = 1;
                item.deptId = item.id;
                item.teamName = item.name;
                item.teamId = item.id;
                item.leaf = item.children.length === 0;
              });
              return resolve(res.datas[0].children);
            } else {
              return resolve([]);
            }
          }).catch(e => {

          });
        } else {
          // 子部门的数据处理，数据来源为点击的节点
          node.data.children.forEach(item => {
            item.isDept = 1;
            item.deptId = item.id;
            item.teamName = item.name;
            item.teamId = item.id;
            item.leaf = item.children.length === 0;
          });
          return resolve(node.data.children);
        }
      } else {
        // 调用团队接口
        getTeamList(teamId).then(res => {
          // 如果是我的部门，做特殊处理,存在子部门
          res.forEach(item => {
            if (item.teamId === '00000000-0000-0000-0000-000000000000') {
              item.hasSubTeams = 1;
              item.isDept = 1;
            } else {
              item.isDept = 0;
            }
          });
          if (res && res.length > 0) {
            if (teamId === '' && this.defaultTid) {
              this.selTeamName = this.defaultTname;
              this.$emit('selTeam', { id: this.defaultTid, name: this.defaultTname, deptid: this.defaultDeptId });
            } else if (node.level === 0) {
              // 第一层拿第一个团队名作为选中名
              this.selTeamName = res[0].teamName;
              this.$emit('selTeam', { id: res[0].teamId, name: res[0].teamName });
            }
            // 多团队，或者存在子团队，显示下拉按钮
            if (res.length > 1 || (res.length === 1 && res[0].hasSubTeams === 1)) {
              this.isShowTeamSel = true;
            }
            res.map(it => {
              it.leaf = !it.hasSubTeams;
              return it;
            });
            return resolve(res);
          }
        }).catch(e => {
          if (node.level === 0) {
            this.$emit('selTeam', {});
            return resolve([{ teamName: this.defaultTname ? this.defaultTname : this.$t('pc_o2o_tip_myTeam').d('我的团队'), leaf: true, teamId: this.defaultTid ? this.defaultTid : '' }]);
          }
        });
      }
    },
    // 团队树点击事件
    handleTeamNodeClick(data, node) {
      this.showTeamSel = false;
      this.selTeamName = data.teamName;
      // 选了部门需要追加部门ID
      if (data.isDept === 1 && data.teamId !== '00000000-0000-0000-0000-000000000000') {
        window.localStorage.setItem('myTeam_TeamDetail', JSON.stringify({ id: '00000000-0000-0000-0000-000000000000', name: data.teamName, deptid: data.teamId }));
        this.$emit('selTeam', { id: '00000000-0000-0000-0000-000000000000', name: data.teamName, deptid: data.teamId });
      } else {
        window.localStorage.setItem('myTeam_TeamDetail', JSON.stringify({ id: data.teamId, name: data.teamName }));
        this.$emit('selTeam', { id: data.teamId, name: data.teamName });
      }
    }
  }
};
</script>

<style lang="scss">
.team-select-self-height {
  max-height: 290px;
}

div[popper-class='team-pop'] .yxt-scrollbar__wrap {
  height: 290px;
}
</style>
